
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Other/Popovers.html",
      function () {
        return require("private-next-pages/Other/Popovers.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Other/Popovers.html"])
      });
    }
  